import { Control } from 'react-hook-form'

import { PreviewSections } from 'Core/interfaces'

export interface ParametersTypeOptions extends LabelValue<number> {
	extra: PreviewSections | null
}

export interface BaseParameterSectionProps {
	control: Control<Parameter.Form.Add>
	disabled?: boolean
}

export enum ParametersSearchFields {
	searchById = 'searchById',
	searchByName = 'searchByName'
}
export declare namespace Parameter {
	interface Basic {
		id: Key
		name: string
		description: string
	}
	interface Parameter {
		name: string
		description: string
		parameterType: Entity
		baseSql: string
		hardcodedChoices: IdValue[]
		isRestrictedByServiceSite: boolean
		serviceSiteColumnName: string
	}

	namespace Form {
		interface Add extends Omit<Parameter, 'parameterType'> {
			multiple: string[]
			single: Key | null
			checkbox: boolean
			find: LabelValue | null
			date: string | null
			parameterTypeId: number | null
		}
	}
	namespace Request {
		interface Add
			extends Omit<Form.Add, 'checkbox' | 'find' | 'multiple' | 'single' | 'date' | 'text'> {
			name: string
			description: string
			parameterTypeId: number | null
			xBaseSql: string
			hardcodedChoices: IdValue[]
			isRestrictedByServiceSite: boolean
			serviceSiteColumnName: string
		}
	}

	namespace Search {
		interface Result {
			[ParametersSearchFields.searchById]: number[]
			[ParametersSearchFields.searchByName]: Entity[]
		}
	}
}
